/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Interaction } from './Interaction';
import {
    InteractionFromJSON,
    InteractionFromJSONTyped,
    InteractionToJSON,
} from './Interaction';

/**
 * 
 * @export
 * @interface PresentResponse
 */
export interface PresentResponse {
    /**
     * 
     * @type {Array<Interaction>}
     * @memberof PresentResponse
     */
    interactions: Array<Interaction>;
    /**
     * 
     * @type {number}
     * @memberof PresentResponse
     */
    count: number;
}

/**
 * Check if a given object implements the PresentResponse interface.
 */
export function instanceOfPresentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "interactions" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PresentResponseFromJSON(json: any): PresentResponse {
    return PresentResponseFromJSONTyped(json, false);
}

export function PresentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'interactions': ((json['interactions'] as Array<any>).map(InteractionFromJSON)),
        'count': json['count'],
    };
}

export function PresentResponseToJSON(value?: PresentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'interactions': ((value.interactions as Array<any>).map(InteractionToJSON)),
        'count': value.count,
    };
}

